/**
 * @ngdoc directive
 * @name fileSelectionChange
 * @description
 * Detect the change event on HTML file fields
 *
 * @memberof common
 *
 * @element INPUT
 * @return {Object} The directive properties.
 */

const FileSelectionChange = () => ({
  restrict: 'A',
  scope: {
    fileSelectionChange: '&',
  },
  link($scope, $element) {
    const element = $element[0];
    const onSelectionChange = ({ target: { files } }) => {
      if (files.length > 0) {
        $scope.fileSelectionChange({ files });
        // Clear element
        element.value = '';
      }
    };

    element.addEventListener('change', onSelectionChange);

    $scope.$on('$destroy', () => {
      element.removeEventListener('change', onSelectionChange);
    });
  },
});

export default FileSelectionChange;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/directives/fileSelectionChange.js